export default "__VITE_ASSET__BPHfeOFs__"